import { requiredNamedObjectSchema } from './named-object.js';
import { interventionInstructionsSchema } from './intervention-instructions.js';
import { IllegalArgumentError } from 'faro-common-model';
import { StudyEntityType } from './study-entity-type.js';
import { baseStudyEntityValidationSchema } from './validation/index.js';
import { z } from 'zod';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
import { nullishToEmptyArray } from '../utils/nullishToEmptyArray.js';
export const interventionGroupLabelMaxLength = 120;
export const interventionGroupNotesMaxLength = 1000;
export const interventionGroupSchema = z.object({
    ...baseStudyEntityValidationSchema.shape,
    entityType: z.literal(StudyEntityType.InterventionGroup).default(StudyEntityType.InterventionGroup),
    interventionInstructions: z.array(interventionInstructionsSchema).nullish().transform(nullishToEmptyArray),
    label: z.string().max(interventionGroupLabelMaxLength).nullish().transform(nullishToUndefined).optional(),
    color: z.string().nullish().transform(nullishToUndefined).optional(),
    use: requiredNamedObjectSchema.nullish().transform(nullishToUndefined).optional(),
    notes: z.string().max(interventionGroupNotesMaxLength).nullish().transform(nullishToUndefined).optional(),
});
export function toInterventionGroup(group) {
    const result = interventionGroupSchema.safeParse(group);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid InterventionGroup object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=intervention-group.js.map